import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonsModule } from '../button/button.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { IconModule } from '../icon/icon.module';
import { MaskedInput } from './axis-datemask-directive';
import { AxisDatePickerComponent } from './axis-datepicker.component';
import { DatePickerInnerComponent } from './datepicker-inner.component';
import { DatepickerTemplateComponent } from './datepicker-template';
import { DatePickerComponent } from './datepicker.component';
import { DatepickerConfig } from './datepicker.config';
import { DatepickerService } from './datepicker.shared.service';
import { AxisDayButtonComponent } from './daybtn.component';
import { DayPickerComponent } from './daypicker.component';
import { DOBComponent } from './dob.component';
import { MonthPickerComponent } from './monthpicker.component';
import { YearPickerComponent } from './yearpicker.component';

@NgModule({
  imports: [
    ButtonsModule,
    CommonModule,
    DropdownModule,
    FormsModule,
    IconModule
  ],
  declarations: [
    AxisDatePickerComponent,
    AxisDayButtonComponent,
    DatePickerComponent,
    DatePickerInnerComponent,
    DOBComponent,
    DayPickerComponent,
    DatepickerTemplateComponent,
    MonthPickerComponent,
    MaskedInput,
    YearPickerComponent
  ],
  exports: [
    AxisDatePickerComponent,
    AxisDayButtonComponent,
    DatePickerComponent,
    DatePickerInnerComponent,
    DayPickerComponent,
    DOBComponent,
    DatepickerTemplateComponent,
    MaskedInput,
    MonthPickerComponent,
    YearPickerComponent
  ],
  providers: [
    DatepickerConfig,
    DatepickerService
  ],
  entryComponents: [
    DatePickerComponent,
    DatepickerTemplateComponent
  ]
})
export class DatepickerModule {}
